import qs from 'qs'

// btoa()：任意值转为 Base64 编码
// atob()：Base64 编码转为原来的值
// id=123&acc=王国&icon=1&picon=url&shoeid=123
export function b64Encode(obj) {
  // let str = qs.stringify(obj)
  // str = decodeURIComponent(str)
  // return btoa(encodeURIComponent(str))
  const str = qs.stringify(obj)
  return btoa(str)
}
export function b64Decode(str) {
  const res = decodeURIComponent(atob(str))
  return qs.parse(res)
}

export function getCopyText(obj) {
  // QQDZZ +Base64(shoeid=123&sendid=234&acc=用户名)
  return 'QQDZZ' + b64Encode(obj)
}
